import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 10px !important;
  }
`;
